<template>
  <roe-modal ref="modal" wrap-class="popup-wrap">
    <div class="popup-inner popup-inner--small">
      <div class="popup-header">
        <h4>Research details</h4>
        <button class="btn-close" @click="$refs.modal.close()"></button>
      </div>
      <div class="popup-content">
        <h2>{{ article.title }}</h2>
        <p>{{ article.paragraph_summary }}</p>
        <div class="popup-actions">
          <button class="btn-primary" @click="openFile(article)">
            View more
          </button>
        </div>
      </div>
    </div>
  </roe-modal>
</template>

<script>
import RoeModal from "@/components/_shared/Modal";
export default {
  name: "RoeArticleView",
  components: { RoeModal },
  data() {
    return {
      article: {}
    };
  },
  methods: {
    open(article) {
      this.article = article;
      this.$refs.modal.open();
    },
    openFile(article) {
      window.open(
        `${process.env.VUE_APP_API_BASE_URL}${article.file_path}`,
        "_blank"
      );
    }
  }
};
</script>
